require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-4-adding-tasks.json") })
        }
      }, "path---article-4-adding-tasks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-4-adding-tasks!./.cache/json/article-4-adding-tasks.json
// module id = 548
// module chunks = 231608221292675